import { SolicitacaoDetalhada } from "model/solicitacao/SolicitacaoDetalhada";
import { Autorizacao } from "view/component/Autorizacao/Autorizacao";
import { Situacoes } from "model/solicitacao/Situacao";


export const solicitacaoAceitaComentario = (solicitacao: SolicitacaoDetalhada, autorizacao: Autorizacao) => {
  if (autorizacao.papeis.Nivel1) {
    return true;
  }

  const situacoes = [Situacoes.EM_ABERTO, Situacoes.EM_ANDAMENTO, Situacoes.AGUARDANDO_PARECER_SOLICITANTE, Situacoes.CONCLUIDO];
  const idSituacao = solicitacao.situacao?.id ?? -1
  
  return situacoes.map(e => e.id).includes(idSituacao)
}